package com.vamvisions.main.components

import androidx.compose.runtime.Composable
import com.vamvisions.main.theme.AppStyleSheet
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.dom.Article
import org.w3c.dom.HTMLElement

/**
 * A self-contained entry on a surface panel, such as one experience or one project. A [glass] card is a frosted
 * surface over the intro background.
 */
@Composable
fun Card(
    glass: Boolean = false,
    attrs: (AttrsScope<HTMLElement>.() -> Unit)? = null,
    content: @Composable () -> Unit,
) {
    Article(attrs = {
        classes(AppStyleSheet.card)
        if (glass) classes(AppStyleSheet.glass)
        attrs?.invoke(this)
    }) {
        content()
    }
}
